<sona-general-layout class="tw-h-full">
    <header sonaGeneralLayoutHeader>
        <h1 class="tw-my-8">{{ 'PAGE.PRIVACY.TITLE' | translate }}</h1>
    </header>
    <section sonaGeneralLayoutContent>
        @if (content().isLoading) {
            <div class="d-flex justify-content-center p-4">
                <sona-spinner />
            </div>
        } @else {
            <div [innerHtml]="content().data"></div>
        }
    </section>
</sona-general-layout>
